import { createApiClient } from "@punchup/utils/apiClient";

export const api = createApiClient({});
